import shuffle from 'lodash/shuffle';
import { Training } from '@/interfaces/class/training';

export default (el: Training) => ({
  ...el,
  enFillersCorrect: el.enFillers ? el.enFillers.split('\n') : [],
  enFillersShuffled: el.enFillers ? shuffle(el.enFillers.split('\n')) : [],
  partResults: {},
});
